import { OVEntity, OVField, OVSearchable } from '@ov-suite/ov-metadata';

@OVEntity({ name: 'ProductSkuPartial' })
export class ProductSkuPartial {
  @OVField({ type: 'number' })
  id: number;

  @OVSearchable()
  @OVField({ type: 'string' })
  name: string;
}

@OVEntity({ name: 'ProductSkuConfiguration', tableName: 'product_sku_configuration' })
export class ProductSkuConfiguration {
  @OVField({ type: 'number' })
  id: number;

  @OVField({ type: 'number' })
  quantity: number;

  @OVField({ type: () => ProductSkuPartial })
  productSku: ProductSkuPartial;
}
